// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ModalCancel_wrap__3CYUq","body":"ModalCancel_body__3b_K3","footer":"ModalCancel_footer__1o4um","icon":"ModalCancel_icon__deiP2","btn":"ModalCancel_btn__16yiZ"};